import { NBALogo } from 'atoms/icons/NBALogo';

export const NBA = () => (
  <>
    <NBALogo />
    <svg
      width="42"
      height="9"
      viewBox="0 0 42 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="m0.4222,0.00225l0,8.928l4.032,0l0,-4.884l5.1,4.884l4.092,0l0,-8.928l-4.032,0l0,4.512l-4.644,-4.512l-4.548,0zm14.086,8.928l9.204,0c2.928,0 3.852,-1.2 3.852,-2.604l0,-0.12c0,-1.584 -1.2,-2.136 -2.196,-2.328c0.756,-0.156 1.68,-0.708 1.68,-1.764l0,-0.096c0,-1.02 -0.684,-2.016 -3.348,-2.016l-9.192,0l0,8.928zm7.572,-6.744c0.636,0 0.852,0.156 0.852,0.504l0,0.024c0,0.324 -0.216,0.516 -0.852,0.516l-3.528,0l0,-1.044l3.528,0zm0.204,3.18c0.816,0 0.996,0.264 0.996,0.612l0,0.024c0,0.348 -0.168,0.66 -0.996,0.66l-3.732,0l0,-1.296l3.732,0zm13.0627,-0.132l-2.52,0l1.248,-2.748l1.272,2.748zm1.704,3.696l4.488,0l-4.572,-8.928l-5.592,0l-4.296,8.928l4.092,0l0.552,-1.236l4.764,0l0.564,1.236z"
        fill="white"
      />
    </svg>
  </>
);
